// extracted by mini-css-extract-plugin
export default {"hd_navi":"header_hd_navi__Nh-B+","active":"header_active__8mNT5"};